import FormValidation from './modules/FormValidation';
import Action from './modules/Action';
import './modules/ConnectingDots';

new FormValidation().render();

const $body = $('body');

// Клик
$body.on('click', '[data-click]', (event) => {
  event.preventDefault();

  const $this = $(event.currentTarget);
  const data = $this.data('click');

  new Action(data, event.currentTarget);
});

$('.js-slider').each((index, element) => {
  const $slider = $(element);
  const data = $slider.data('slider');

  $slider.slick(data);
});
